'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../../_virtual/_tslib.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
var useBottomModalContainer = require('./useBottomModalContainer.js');

const BottomModalContainer = ({ children, onClose, isFixedHeight = true })=>{
    const { containerRef, currentTranslate } = useBottomModalContainer({
        onClose
    });
    return jsxRuntime.jsxs(Box, {
        ref: containerRef,
        style: {
            transform: `translateY(${currentTranslate}px)`
        },
        className: tailwindMerge.twJoin('z-30 w-full rounded-t-3xl bg-w-white', isFixedHeight ? 'h-[60dvh]' : 'h-fit'),
        "data-testid": "design-system--bottom-modal-container",
        children: [
            jsxRuntime.jsx(Box, {
                className: "flex items-center justify-center pb-5 pt-2",
                "data-testid": "design-system--bottom-modal-container-header",
                id: "bottom-modal-header",
                children: jsxRuntime.jsx(Box, {
                    className: "h-1 w-8 rounded-full bg-w-gray-200"
                })
            }),
            children
        ]
    });
};

module.exports = BottomModalContainer;
